/**
 * Whether the editor at a place was a v3 one last time (founder 19.10.2026: the header first showed the old bar,
 * then switched once KEditor knew). Keyed by the page's parent path (its project or folder), as the editor version
 * is per project. The header starts with the remembered kind; KEditor's answer still decides.
 */
const KEY = 'wm-v3-editor';

function placeOf(path) {
  return String(path || '').replace(/\/+$/, '').replace(/\/[^/]*$/, '');
}

function readAll() {
  try {
    return JSON.parse(window.localStorage.getItem(KEY)) || {};
  } catch (e) {
    return {};
  }
}

export function rememberedV3(path) {
  return readAll()[placeOf(path)] === true;
}

export function rememberV3(path, v3) {
  const all = readAll();
  all[placeOf(path)] = v3 === true;
  try {
    window.localStorage.setItem(KEY, JSON.stringify(all));
  } catch (e) {
    // Private mode or full storage: the header waits for KEditor as before.
  }
}
